import { MapaToolsComponent } from './mapa-tools';
import { MapIconIMG } from './mapa-icons-img';
import { Injectable } from "@angular/core";

declare var google: any;

@Injectable()
export class mapIcon extends MapaToolsComponent {

    public iconImg = new MapIconIMG();

    public iconColor:any = {
        verde: '#7cb342',
        rojo: '#F43734',
        naranja: '#ff6a00',
        amarillo: '#f39c12'
    };

    markerIcon(tipo, color, direccion, scaleIcon:any = false){
      var iconMarker;        
      //if (tipo!='flecha'){
           iconMarker = this.getIcon(tipo, color, direccion);
      // } else {
      //   scaleIcon = (scaleIcon) ? scaleIcon : 3;
      //   iconMarker = {
      //     path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      //     rotation: direccion,
      //     scale: scaleIcon,
      //     fillColor: '#16a085',
      //     fillOpacity: 0.8,
      //     strokeColor: '#2ecc71',
      //     strokeOpacity: 0.9,
      //     strokeWeight: 2
      //   }
      // }
      return iconMarker;
    }

    getIcon(tipo:any, color:any, rotate:any){
        var w, h, url, size;        
        switch (tipo) { 
            case 'stop':
                w = 44; h = 44;
                size = (w > h) ? w : h;
                url = this.iconPath('stop', size, size, color, rotate);
                break;
            case 'auto':
                w = 50; h = 50;
                size = (w>h) ? w : h;
                url = this.iconPath('auto',size, size, color, rotate);                                               
                break;
            case 'flecha':
                w = 25; h = 25;
                size = (w>h) ? w : h;
                url = this.iconPath('flecha', size, size, color, rotate);
                break;
            case 'alerta':
                w = 25; h = 25;
                size = (w>h) ? w : h;
                url = this.iconPath('alerta', size, size, color, rotate);
                break;
            case 'punto':
                w = 25; h = 25;
                size = (w > h) ? w : h;
                url = this.iconPath('punto', size, size, color, rotate);
            break;
            case 'combustible':
                w = 25; h = 25;
                size = (w > h) ? w : h;
                url = this.iconPath('combustible', size, size, color, rotate);
            break;
            case 'temperatura':
                w = 25; h = 25;
                size = (w > h) ? w : h;
                url = this.iconPath('temperatura', size, size, color, rotate);
            break;
            default:
                w = 29; h = 40;
                url = this.iconPath('punto', size, size, color, rotate);
        }
        
        var archor_x = (rotate > 0 && rotate <= 180) ? w : w / 2;
        var archor_y = (rotate > 180 && rotate <= 360) ? w / 2 : w;

        var iconMarker = {
            size: new google.maps.Size(size, size),
            url: url,
            anchor: new google.maps.Point(w/2, h/2),
            origin: new google.maps.Point(0, 0),
            //scaledSize: scaledSize
        }
        return iconMarker;        
    }

    getColor(color){
        var result;
        switch (color) {
            case 'verde': result = this.iconColor.verde; break;
            case 'rojo': result = this.iconColor.rojo; break;
            case 'naranja': result = this.iconColor.naranja; break;
            case 'amarillo': result = this.iconColor.amarillo; break;
        }
        return result;
    }

    iconPath(tipo, w_ico, h_ico, color, rotate){
      var color = this.getColor(color);
      var icon;
      if (tipo =='auto') { icon = this.iconImg.auto(w_ico, h_ico, color, rotate); }
      if (tipo =='flecha') { icon = this.iconImg.flecha(w_ico, h_ico, rotate); }
      if (tipo == 'stop') { icon = this.iconImg.stop(w_ico, h_ico, this.iconColor.rojo); }
      if (tipo == 'alerta') { icon = this.iconImg.alerta(color); }
      if (tipo == 'punto') { icon = this.iconImg.punto(color); }
      if (tipo == 'combustible') { icon = this.iconImg.combustible(color); }
      if (tipo == 'temperatura') { icon = this.iconImg.temperatura(color); }

      return 'data:image/svg+xml;utf-8;base64, ' + btoa(icon);
    }

}